import { ElementTypes } from '../element-types';

export class Alert {
  static readonly AcceptCookies: string = `${ElementTypes.Button}-accept-cookies`;
}
